import { PageTemplateContent, SkeletonLoading } from 'app/common/templates-next/page-template'


export const StatementsLoading = () => {
  return (
    <PageTemplateContent>
      <SkeletonLoading rows={10} />
    </PageTemplateContent>
  )
}
